<!--
 * @Author: Lemon C
 * @Date: 2024-05-14 16:55:03
 * @LastEditTime: 2024-12-14 14:58:51
-->
<template>
    <div class="sup-bady">
        <DocsTypeSwitch class="top-type-switch" :switch_type="1" :title_name="'消息中心'" :needSerarch="false"> </DocsTypeSwitch>
        <div class="docs-page">
            <MsgTypeComp class="msg-type-comp" ref="ref_msg_type_comp" :msg_type_callback="msg_type_callback"></MsgTypeComp>
            <MsgListComp
                class="msg-list-comp"
                :msg_request_type="msg_type"
                :comp_msg_item_callback="comp_msg_item_callback"
                :comp_msg_update_callback="comp_msg_update_callback"></MsgListComp>
            <MsgContComp class="msg-cont-comp" :msg_list_item="msg_list_sel_item"></MsgContComp>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { nextTick, ref } from 'vue';
import DocsTypeSwitch from '@/components/Docs/DocsTypeSwitch.vue';
import MsgTypeComp from '@/components/Message/MsgTypeComp.vue';
import MsgListComp from '@/components/Message/MsgListComp.vue';
import MsgContComp from '@/components/Message/MsgContComp.vue';

const ref_msg_type_comp = ref(null);
const msg_type = ref(0);
const msg_list_sel_item = ref(null);

// MARK CallBack  类型点击
const msg_type_callback = (type) => {
    msg_type.value = type;
    msg_list_sel_item.value = {};
};
// MARK CallBack  列表点击
const comp_msg_item_callback = (item) => {
    // console.log(item);
    msg_list_sel_item.value = item;
};
// MARK CallBack 更新
const comp_msg_update_callback = () => {
    ref_msg_type_comp.value.update_data();
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-bady {
    height: 100%;
    flex-direction: column;
    overflow: hidden;
    background-color: var(--color-main-light-bg-white);

    .top-type-switch {
        position: absolute;
        top: 0;
        left: 0;
        z-index: var(--type-switch-z-index);
    }

    .docs-page {
        position: relative;
        margin-top: 80px;
        width: 100%;
        height: calc(100% - 80px);
        background-color: var(--color-main-light-bg-white);
        display: flex;
        overflow: hidden;

        .msg-type-comp {
            width: 280px;
            height: 100%;
        }

        .msg-list-comp {
            width: 390px;
            height: 100%;
        }

        .msg-cont-comp {
            flex: 1;
        }
    }
}
</style>
